<template>
    <div class="Info">
        <div class="InfoTop">
            <!-- <div class="InfoTopBtn BgBlue" @click="handleProjectClick" v-if="showProjectBtn">项目申请</div> -->
            <div class="InfoTopBtn BgBlue" @click="handleProjectClick">项目申请</div>
        </div>
        <div class="PublishCont">
            <el-table :data="Data" style="width: 100%">
                <el-table-column prop="id" label="序号" width="80"></el-table-column>
                <el-table-column prop="title" label="项目名称" width="180"></el-table-column>
                <el-table-column prop="project_type" label="项目类型" width="120">
                    <template slot-scope="scope">
                        {{ scope.row.user_group_id === 6 ? '学历教育' : '继续教育' }}
                    </template>
                </el-table-column>
                <el-table-column prop="start_date" label="开始时间" width="120"></el-table-column>
                <el-table-column prop="end_date" label="结束时间" width="120">
                    <template slot-scope="scope">
                        {{ scope.row.end_date || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="total_hours" label="总课时" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.total_hours || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="rejection" label="驳回原因" min-width="180">
                    <template slot-scope="scope">
                        {{ scope.row.rejection || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="ToggleLock(scope.row)">详情</el-button>
                        <el-button size="mini" type="primary" plain @click="handleEdit(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="PageDis" v-if="Data.length > 0">
            <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"
                @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page"
                :hide-on-single-page="false"></el-pagination>
        </div>
        <!-- 项目类型选择弹窗 -->
        <el-dialog title="选择项目类型" :visible.sync="showTypeDialog" width="30%" :show-close="true">
            <div class="project-type-select">
                <el-radio-group v-model="selectedProjectType">
                    <el-radio :label="6">学历教育项目</el-radio>
                    <el-radio :label="7">继续教育项目</el-radio>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showTypeDialog = false">取消</el-button>
                <el-button type="primary" @click="handleTypeSelect">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="PublishBlon" :width="Wid" :show-close="false" @close="LockBlon = false">
            <div class="CommDig">
                <!-- 学历教育项目详情查看模式 -->
                <div v-if="LockData.user_group_id === 6 && LockBlon">
                    <div class="DigItem">
                        <div class="DigTit">专业名称</div>
                        <div class="DigCon">{{ LockData.title }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">专业介绍</div>
                        <div class="DigCon">{{ LockData.synopsis }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">开始时间</div>
                        <div class="DigCon">{{ LockData.start_date }}</div>
                    </div>
                    <div class="DigItem" v-if="LockData.img">
                        <div class="DigTit">图片</div>
                        <div class="DigCon">
                            <img class="LockImg" :src="$Global.CommImgHttp + LockData.img" alt=""
                                @click="OpenLock(LockData.img)">
                        </div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">内容</div>
                        <div class="DigCon" v-html="LockData.content"></div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">驳回原因</div>
                        <div class="DigCon">{{ LockData.rejection || '-' }}</div>
                    </div>
                </div>

                <!-- 学历教育项目申请编辑模式 -->
                <div v-if="(!LockBlon && !LockData.user_group_id) || educationEditMode">
                    <div class="DigItem">
                        <div class="DigTit">专业名称</div>
                        <input type="text" v-model="SetData.title">
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">专业介绍</div>
                        <input type="text" v-model="SetData.synopsis">
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">开始时间</div>
                        <el-date-picker 
                            v-model="SetData.start_time" 
                            type="date" 
                            placeholder="选择项目开始时间" 
                            style="width: calc(100% - 85px); padding: 0">
                        </el-date-picker>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">文件上传</div>
                        <div class="upload-container">
                            <el-upload 
                                action="none" 
                                :show-file-list="false" 
                                :http-request="UpFile">
                                <div class="StepCommFileBtn">上传</div>
                            </el-upload>
                            <div class="StepCommFileLock" v-if="SetData.img" @click="OpenLock(SetData.img)">查看</div>
                        </div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">内容</div>
                        <quill-editor 
                            class="Wid500" 
                            v-model="SetData.content" 
                            ref="myQuillEditor"
                            :options="editorOption">
                        </quill-editor>
                    </div>
                </div>

                <!-- 继续教育项目详情 -->
                <div v-if="LockData.user_group_id === 7">
                    <div class="form-section">
                        <div class="section-title">项目基础信息</div>
                        <div class="DigItem">
                            <div class="DigTit">项目名称</div>
                            <div class="DigCon">{{ LockData.title }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">项目类型</div>
                            <div class="DigCon">{{ getProjectTypeText(LockData.project_type) }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">开始时间</div>
                            <div class="DigCon">{{ LockData.start_date }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">结束时间</div>
                            <div class="DigCon">{{ LockData.end_date }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">项目课时</div>
                            <div class="DigCon">{{ LockData.total_hours }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">目标学员</div>
                            <div class="DigCon">{{ LockData.target_students }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">预期人数</div>
                            <div class="DigCon">{{ LockData.expected_students }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">收费标准</div>
                            <div class="DigCon">{{ LockData.fee }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">可行性分析</div>
                            <div class="DigCon">{{ LockData.feasibility }}</div>
                        </div>
                        <div class="DigItem">
                            <div class="DigTit">驳回原因</div>
                            <div class="DigCon">{{ LockData.rejection || '-' }}</div>
                        </div>
                    </div>

                    <!-- 课程信息 -->
                    <div class="form-section" v-if="LockData.course && LockData.course.length">
                        <div class="section-title">课程信息</div>
                        <el-table :data="LockData.course" border style="width: 100%">
                            <el-table-column prop="course_module" label="课程模块" width="180"></el-table-column>
                            <el-table-column prop="teaching_objective" label="教学目标" width="180"></el-table-column>
                            <el-table-column prop="content" label="课程内容" width="180"></el-table-column>
                            <el-table-column prop="teacher" label="讲师" width="120"></el-table-column>
                            <el-table-column prop="hours" label="课时" width="120"></el-table-column>
                            <el-table-column prop="remark" label="备注"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 师资信息 -->
                    <div class="form-section" v-if="LockData.teachers && LockData.teachers.length">
                        <div class="section-title">师资信息</div>
                        <el-table :data="LockData.teachers" border style="width: 100%">
                            <el-table-column prop="name" label="姓名" width="180"></el-table-column>
                            <el-table-column prop="title" label="职称" width="180"></el-table-column>
                            <el-table-column prop="company" label="所属单位" width="180"></el-table-column>
                            <el-table-column prop="specialty" label="专业领域" width="180"></el-table-column>
                            <el-table-column prop="remark" label="备注"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 培训方案 -->
                    <div class="form-section" v-if="LockData.training_program">
                        <div class="section-title">培训方案</div>
                        <el-button type="primary" size="small" @click="OpenLock(LockData.training_program)">
                            查看培训方案（PDF）
                        </el-button>
                    </div>

                    <!-- 过往项目经验 -->
                    <div class="form-section" v-if="LockData.last_experience">
                        <div class="section-title">过往相似项目经验</div>
                        <div class="experience-files">
                            <div class="experience-file" v-for="(file, index) in getExperienceFiles" :key="index">
                                <img class="LockImg" :src="$Global.CommImgHttp + file" alt=""
                                    @click="OpenLock(file)">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 底部按钮 -->
            <div class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="PublishSuc" v-if="((!LockBlon && !LockData.user_group_id) || educationEditMode)">保 存</el-button>
            </div>
        </el-dialog>
        <!-- 图片样式的项目申请弹窗 -->
        <el-dialog :visible.sync="imageDialogVisible" :width="Wid" :show-close="true" title="继续教育项目申请">
            <div class="image-project-form">
                <div class="form-section">
                    <div class="section-title">项目基础信息</div>
                    <el-form :model="imageProjectForm" label-width="100px">
                        <el-form-item label="项目名称">
                            <el-input v-model="imageProjectForm.title"></el-input>
                        </el-form-item>
                        <el-form-item label="项目类型">
                            <el-radio-group v-model="imageProjectForm.type">
                                <el-radio label="线上" >线上</el-radio>
                                <el-radio label="线下" >线下</el-radio>
                                <el-radio label="线上线下结合">线上线下结合</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="项目周期">
                            <el-date-picker
                                v-model="imageProjectForm.dateRange"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="项目课时">
                            <el-input v-model="imageProjectForm.hours"></el-input>
                        </el-form-item>
                        <el-form-item label="目标学员群体">
                            <el-input v-model="imageProjectForm.targetStudents"></el-input>
                        </el-form-item>
                        <el-form-item label="预期培训人数">
                            <el-input v-model="imageProjectForm.expectedNumber"></el-input>
                        </el-form-item>
                        <el-form-item label="收费标准">
                            <el-input v-model="imageProjectForm.fee"></el-input>
                        </el-form-item>
                        <el-form-item label="项目可行性">
                            <el-input type="textarea" v-model="imageProjectForm.feasibility" :rows="4"
                                placeholder="请输入项目可行性分析（如政策要求、技能缺口、学员痛点），与同类项目的差异化优势（创新点、师资优势、资源配套）"></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="form-section">
                    <div class="section-title">课程信息</div>
                    <el-table :data="imageProjectForm.courses" border style="width: 100%">
                        <el-table-column label="课程模块" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.module" placeholder="请输入课程模块"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="教学目标" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.objective" placeholder="请输入教学目标"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="课程内容" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.content" placeholder="请输入课程内容"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="讲师" width="120">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.teacher" placeholder="请输入讲师"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="课时" width="120">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.hours" placeholder="请输入课时"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.remark" placeholder="请输入备注"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="120">
                            <template slot-scope="scope">
                                <el-button type="text" @click="removeCourse(scope.$index)" v-if="imageProjectForm.courses.length > 1">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-course-btn">
                        <el-button type="primary" icon="el-icon-plus" @click="addCourse">添加课程</el-button>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title">师资信息</div>
                    <el-table :data="imageProjectForm.teachers" border style="width: 100%">
                        <el-table-column label="姓名" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.name" placeholder="请输入姓名"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="职称" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.title" placeholder="请输入职称"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="所属单位" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.unit" placeholder="请输入所属单位"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="专业领域" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.field" placeholder="请输入专业领域"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.remark" placeholder="请输入备注"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="120">
                            <template slot-scope="scope">
                                <el-button type="text" @click="removeTeacher(scope.$index)" v-if="imageProjectForm.teachers.length > 1">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-course-btn">
                        <el-button type="primary" icon="el-icon-plus" @click="addTeacher">添加师资</el-button>
                    </div>
                </div>

                <!-- 培训方案（PDF）上传 -->
                <div class="form-section">
                    <div class="section-title">培训方案</div>
                    <div class="experience-upload">
                        <el-upload
                            class="upload-demo"
                            action="none"
                            :http-request="uploadTrainingProgramFile"
                            :on-preview="handlePreview"
                            :on-remove="handleTrainingProgramRemove"
                            :before-remove="beforeRemove"
                            :limit="1"
                            :file-list="trainingProgramFileList"
                            accept=".pdf">
                            <el-button size="small" type="primary">上传培训方案（PDF）</el-button>
                            <div slot="tip" class="el-upload__tip">仅支持PDF格式，单个文件不超过10MB</div>
                        </el-upload>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title">过往相似项目经验</div>
                    <div class="experience-upload">
                        <el-upload
                            class="upload-demo"
                            action="none"
                            :http-request="uploadExperienceFile"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="5"
                            :file-list="fileList">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">可上传多个文件，支持PDF、Word、Excel等格式，单个文件不超过10MB</div>
                        </el-upload>
                    </div>
                </div>

                <div class="form-footer">
                    <el-button @click="closeImageDialog">取消</el-button>
                    <el-button type="primary" @click="submitImageProject">{{ imageEditMode ? '保存' : '提交' }}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
export default {
    components: { quillEditor },
    data() {
        return {
            Wid: "60%",
            Data: [],
            LockData: "",
            LockBlon: false,
            total: 0,
            page: 1,
            SizePage: 10,
            PublishBlon: false,
            showProjectBtn: false,
            showTypeDialog: false,
            selectedProjectType: null,
            userGroups: [],
            SetData: {
                content: "",
                img: "",
                projects_type_id: "",
                title: "",
                synopsis: "",
                start_time: ""
            },
            editorOption: this.$Global.CommEditor,
            projectsTypeList: [],
            imageDialogVisible: false,
            fileList: [],
            trainingProgramFileList: [],
            editingProjectId: null,
            educationEditMode: false,
            imageEditMode: false,
            imageProjectForm: {
                title: '',
                type: '',
                dateRange: [],
                hours: '',
                targetStudents: '',
                expectedNumber: '',
                fee: '',
                feasibility: '',
                courses: [{
                    module: '',
                    objective: '',
                    content: '',
                    teacher: '',
                    hours: '',
                    remark: ''
                }],
                teachers: [{
                    name: '',
                    title: '',
                    unit: '',
                    field: '',
                    remark: ''
                }],
                experienceFiles: [],
                training_program: '',
            },
            statusMap: {
                '0': '待提交',
                '1': '待缴费',
                '2': '待审核',
                '3': '已驳回',
                '4': '待审核',
                '5': '已驳回',
                '6': '完成'
            },
        }
    },
    mounted() {
        this.Wid = this.$Global._isMobile() ? "95%" : "60%";
        this.GetData();
        // this.ProjectsType();
        this.checkUserGroup();
    },
    methods: {
        GetData() {
            this.$post("api/user/projectList", {
                page: this.page,
                limit: this.SizePage,
            }).then(res => {
                if (res.data.code == 1) {
                    this.total = res.data.data.total;
                    this.Data = res.data.data.data;
                }
            })
        },
        ProjectsType() {
            this.$get("api/index/projectsType").then(res => {
                if (res.data.code == 1) {
                    this.projectsTypeList = res.data.data;
                }
            })
        },
        ToggleLock(res) {
            this.LockData = res;
            this.LockBlon = true;
            this.Toggle();
            console.log(this.LockData)
        },
        Toggle() {
            this.PublishBlon = !this.PublishBlon;
        },
        PublishSuc() {
            // 学历教育项目的请求体
            const formData = new FormData();
            
            // 添加基本信息到row
            formData.append('row[title]', this.SetData.title); // 专业名称
            formData.append('row[synopsis]', this.SetData.synopsis); // 专业介绍
            formData.append('row[start_date]', this.formatDate(this.SetData.start_time)); // 开始时间
            formData.append('row[img]', this.SetData.img); // 文件上传url
            formData.append('row[user_group_id]', "6"); // 学历教育项目
            formData.append('row[content]', this.SetData.content || ''); // 内容
            if (this.educationEditMode && this.editingProjectId) {
                formData.append('row[id]', this.editingProjectId);
            }
            
            const api = this.educationEditMode ? "api/user/editProject" : "api/user/addProject";
            this.$post(api, formData).then(res => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg)
                    this.GetData();
                    this.handleCancel();
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        UpFile(res) {
            var file = res.file;
            var fd = new FormData()
            fd.append('file', file);
            this.$Global.FileUpData(fd, (res) => {
                this.SetData.img = res.data.url;
            })
        },
        OpenLock(res) {
            window.open(this.$Global.CommImgHttp + res)
        },
        SizeChange(val) {
            this.SizePage = val;
            this.GetData();
        },
        PageChange(val) {
            this.page = val;
            this.GetData();
        },
        checkUserGroup() {
            this.$post("api/user/getUserInfo")
            .then(res => {
                if (res.data.code == 1) {
                    const userGroup = res.data.data.company_user_group || [];
                    this.userGroups = userGroup;
                    this.showProjectBtn = userGroup.includes(6) || userGroup.includes(7);
                }
            });
        },
        handleProjectClick() {
            if (this.userGroups.includes(6) && this.userGroups.includes(7)) {
                // 同时有权限6和7，显示选择弹窗
                this.showTypeDialog = true;
            } else if (this.userGroups.includes(7)) {
                // 只有权限7，直接显示继续教育项目弹窗
                this.showImageDialog();
            } else if (this.userGroups.includes(6)) {
                // 只有权限6，直接显示学历教育项目弹窗
                this.Toggle();
            }
        },
        handleTypeSelect() {
            this.showTypeDialog = false;
            if (this.selectedProjectType === 6) {
                // 选择了学历教育项目
                this.Toggle();
            } else if (this.selectedProjectType === 7) {
                // 选择了继续教育项目
                this.showImageDialog();
            }
        },
        showImageDialog() {
            this.imageDialogVisible = true;
        },
        submitImageProject() {
            // 项目类型映射
            let projectTypeMap = {
                '线上': '1',
                '线下': '2',
                '线上线下结合': '3'
            };
            
            // 继续教育项目的请求体
            const formData = new FormData();
            
            // 添加基本信息到row
            formData.append('row[title]', this.imageProjectForm.title); // 项目名称
            formData.append('row[project_type]', projectTypeMap[this.imageProjectForm.type] || ''); // 项目类型
            formData.append('row[start_date]', this.imageProjectForm.dateRange[0] ? this.formatDate(this.imageProjectForm.dateRange[0]) : ''); // 开始时间
            formData.append('row[end_date]', this.imageProjectForm.dateRange[1] ? this.formatDate(this.imageProjectForm.dateRange[1]) : ''); // 结束时间
            formData.append('row[total_hours]', this.imageProjectForm.hours); // 项目课时
            formData.append('row[target_students]', this.imageProjectForm.targetStudents); // 目标学员群体
            formData.append('row[expected_students]', this.imageProjectForm.expectedNumber); // 预期培训人数
            formData.append('row[fee]', this.imageProjectForm.fee); // 收费标准
            formData.append('row[feasibility]', this.imageProjectForm.feasibility); // 项目可行性
            formData.append('row[user_group_id]', "7"); // 继续教育项目
            formData.append('row[synopsis]', ''); // 添加空的synopsis字段
            if (this.imageEditMode && this.editingProjectId) {
                formData.append('row[id]', this.editingProjectId);
            }

            // 添加课程信息
            this.imageProjectForm.courses.forEach((course, index) => {
                formData.append(`courses[${index}][course_module]`, course.module || ''); 
                formData.append(`courses[${index}][teaching_objective]`, course.objective || '');
                formData.append(`courses[${index}][content]`, course.content || '');
                formData.append(`courses[${index}][teacher]`, course.teacher || '');
                formData.append(`courses[${index}][hours]`, course.hours || '');
                formData.append(`courses[${index}][remark]`, course.remark || '');
            });

            // 添加师资信息
            this.imageProjectForm.teachers.forEach((teacher, index) => {
                formData.append(`teachers[${index}][name]`, teacher.name || '');
                formData.append(`teachers[${index}][title]`, teacher.title || '');
                formData.append(`teachers[${index}][company]`, teacher.unit || '');
                formData.append(`teachers[${index}][specialty]`, teacher.field || '');
                formData.append(`teachers[${index}][remark]`, teacher.remark || '');
            });

            // 添加过往相似项目经验
            if (this.imageProjectForm.experienceFiles && this.imageProjectForm.experienceFiles.length > 0) {
                const fileUrls = this.imageProjectForm.experienceFiles.map(file => file.url).join(',');
                formData.append('row[last_experience]', fileUrls);
            }

            // 添加培训方案（PDF）
            if (this.imageProjectForm.training_program) {
                formData.append('row[training_program]', this.imageProjectForm.training_program);
            }
            
            // 发送请求
            const api = this.imageEditMode ? "api/user/editProject" : "api/user/addProject";
            this.$post(api, formData).then(res => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                    this.closeImageDialog();
                    this.GetData(); // 刷新列表
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        handleEdit(row) {
            this.editingProjectId = row.id;
            if (row.user_group_id === 6) {
                this.educationEditMode = true;
                this.imageEditMode = false;
                this.LockData = { user_group_id: 6 };
                this.LockBlon = false;
                this.SetData = {
                    ...this.SetData,
                    title: row.title || '',
                    synopsis: row.synopsis || '',
                    start_time: row.start_date || '',
                    img: row.img || '',
                    content: row.content || '',
                };
                this.PublishBlon = true;
                return;
            }
            if (row.user_group_id === 7) {
                this.imageEditMode = true;
                this.educationEditMode = false;
                this.fillImageProjectForm(row);
                this.showImageDialog();
            }
        },
        fillImageProjectForm(row) {
            const typeMap = {
                '1': '线上',
                '2': '线下',
                '3': '线上线下结合'
            };
            this.imageProjectForm.title = row.title || '';
            this.imageProjectForm.type = typeMap[String(row.project_type)] || '';
            this.imageProjectForm.dateRange = [
                row.start_date || '',
                row.end_date || ''
            ];
            this.imageProjectForm.hours = row.total_hours || '';
            this.imageProjectForm.targetStudents = row.target_students || '';
            this.imageProjectForm.expectedNumber = row.expected_students || '';
            this.imageProjectForm.fee = row.fee || '';
            this.imageProjectForm.feasibility = row.feasibility || '';
            this.imageProjectForm.courses = (row.course || row.courses || []).map(course => ({
                module: course.course_module || '',
                objective: course.teaching_objective || '',
                content: course.content || '',
                teacher: course.teacher || '',
                hours: course.hours || '',
                remark: course.remark || '',
            }));
            if (!this.imageProjectForm.courses.length) {
                this.addCourse();
            }
            this.imageProjectForm.teachers = (row.teachers || []).map(teacher => ({
                name: teacher.name || '',
                title: teacher.title || '',
                unit: teacher.company || teacher.unit || '',
                field: teacher.specialty || teacher.field || '',
                remark: teacher.remark || '',
            }));
            if (!this.imageProjectForm.teachers.length) {
                this.addTeacher();
            }
            this.imageProjectForm.training_program = row.training_program || '';
            this.trainingProgramFileList = row.training_program ? [{
                name: '培训方案.pdf',
                url: row.training_program
            }] : [];
            this.imageProjectForm.experienceFiles = this.getLastExperienceFiles(row.last_experience);
            this.fileList = this.imageProjectForm.experienceFiles.map((file, index) => ({
                name: `经验文件${index + 1}`,
                url: file.url
            }));
        },
        closeImageDialog() {
            this.imageDialogVisible = false;
            this.imageEditMode = false;
            this.editingProjectId = null;
        },
        getLastExperienceFiles(lastExperience) {
            if (!lastExperience) return [];
            return lastExperience.split(',').map((file, index) => ({
                name: `经验文件${index + 1}`,
                url: file.trim()
            }));
        },
        // 格式化日期为 yyyy-MM-dd
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        addCourse() {
            this.imageProjectForm.courses.push({
                module: '',
                objective: '',
                content: '',
                teacher: '',
                hours: '',
                remark: ''
            });
        },
        removeCourse(index) {
            this.imageProjectForm.courses.splice(index, 1);
        },
        addTeacher() {
            this.imageProjectForm.teachers.push({
                name: '',
                title: '',
                unit: '',
                field: '',
                remark: ''
            });
        },
        removeTeacher(index) {
            this.imageProjectForm.teachers.splice(index, 1);
        },
        uploadExperienceFile(params) {
            const file = params.file;
            const fd = new FormData();
            fd.append('file', file);
            
            this.$Global.FileUpData(fd, (res) => {
                if (res.code === 1) {
                    this.imageProjectForm.experienceFiles.push({
                        name: file.name,
                        url: res.data.url
                    });
                    this.$message.success('文件上传成功');
                } else {
                    this.$message.error('文件上传失败');
                }
            });
        },
        // 培训方案上传（仅 PDF）
        uploadTrainingProgramFile(params) {
            const file = params.file;
            const fd = new FormData();
            fd.append('file', file);

            this.$Global.FileUpData(fd, (res) => {
                if (res.code === 1) {
                    this.imageProjectForm.training_program = res.data.url;
                    this.trainingProgramFileList = [{
                        name: file.name,
                        url: res.data.url
                    }];
                    this.$message.success('培训方案上传成功');
                } else {
                    this.$message.error('培训方案上传失败');
                }
            });
        },
        handlePreview(file) {
            window.open(this.$Global.CommImgHttp + file.url);
        },
        handleRemove(file) {
            const index = this.imageProjectForm.experienceFiles.findIndex(item => item.url === file.url);
            if (index > -1) {
                this.imageProjectForm.experienceFiles.splice(index, 1);
            }
        },
        handleTrainingProgramRemove() {
            this.imageProjectForm.training_program = '';
            this.trainingProgramFileList = [];
        },
        beforeRemove(file) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        getStatusType(status) {
            const typeMap = {
                '0': 'info',      // 待提交 - 灰色
                '1': 'warning',   // 待缴费 - 黄色
                '2': 'primary',   // 形式待审核 - 蓝色
                '3': 'danger',    // 形式已驳回 - 红色
                '4': 'primary',   // 专家待审核 - 蓝色
                '5': 'danger',    // 专家已驳回 - 红色
                '6': 'success'    // 完成 - 绿色
            }
            return typeMap[status] || 'info'
        },
        getStatusText(status) {
            return this.statusMap[status] || '未知状态'
        },
        getProjectTypeText(type) {
            const typeMap = {
                '1': '线上',
                '2': '线下',
                '3': '线上线下结合'
            };
            return typeMap[type] || '未知';
        },
        handleCancel() {
            this.PublishBlon = false;
            this.LockData = "";
            this.educationEditMode = false;
            this.editingProjectId = null;
        },
    },
    computed: {
        getExperienceFiles() {
            if (!this.LockData.last_experience) return [];
            return this.LockData.last_experience.split(',').map(file => file.trim());
        }
    },
}
</script>
<style>
.Wid500 .ql-editor {
    height: 150px;
    /* 设置编辑器的高度 */
}
</style>
<style scoped>
.Wid500 {
    width: calc(100% - 85px) !important;
    max-width: 100%;
}

.InfoTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
}

.InfoTopBtn {
    padding: 5px 20px;
    background: #FFFFFF;
    font-weight: 400;
    font-size: 18px;
    color: #0385EB;
    border-radius: 5px;
    border: 2px solid #0385EB;
    margin-right: 20px;
    cursor: pointer;
}

.InfoTopBtn.BgBlue {
    background: #0385EB;
    color: #fff;
}

.PublishItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
}

.PublishItem .Title {
    color: #027cfb;
    font-size: 16px;
    font-weight: 400;
}

.PublishItem .Time {
    color: #666;
    font-size: 14px;
}

.PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.StepCommFileBtn {
    font-size: 16px;
    padding: 3px 35px;
    background: #F5F5F5;
    border-radius: 5px;
    border: 1px solid #CCCCCC;
    text-align: center;
    cursor: pointer;
}

.StepCommFileLock {
    font-size: 16px;
    color: #0385EB;
    padding: 0 10px;
}

.CommDig {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    max-height: 80vh;
    overflow-y: auto;
    padding: 20px;
}

.CommDig > div {
    width: 100%;
    max-width: 100%;
}

.DigItem {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    width: 100%;
}

.DigItem .DigTit {
    font-size: 16px;
    color: #000000;
    margin-right: 20px;
    min-width: 65px;
    flex-shrink: 0;
}

.DigItem input,
.DigItem textarea,
.DigItem .el-select {
    width: calc(100% - 85px);
    max-width: 100%;
    border-radius: 10px;
    border: solid 1px #e1e1e1;
    padding: 15px;
    outline: none;
}

.DigBtns {
    display: flex;
    align-items: center;
    justify-content: center;
}

.DigBtns .Btn {
    background-color: #f6faff;
    border-radius: 10px;
    border: solid 1px #d6e5ff;
    font-size: 16px;
    color: #2354f4;
    padding: 10px 40px;
    cursor: pointer;
}

.DigBtns .Btn:hover {
    box-shadow: 0 0 10px #b6d0ed;
}

.DigBtns .Btn.Blue {
    background-color: #027cfb;
    color: #fff;
    margin-left: 20px;
}

.LockImg {
    width: 40px;
    height: 40px;
}

.project-type-select {
    text-align: center;
    padding: 20px 0;
}

.image-project-form {
    padding: 20px;
}

.form-section {
    margin-bottom: 30px;
}

.section-title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 4px solid #409EFF;
}

.image-project-form .el-form-item {
    margin-bottom: 20px;
}

.image-project-form .el-input,
.image-project-form .el-date-picker {
    width: 100%;
}

.image-project-form .el-radio-group {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.add-course-btn {
    margin-top: 20px;
    text-align: center;
}

.form-footer {
    text-align: center;
    margin-top: 30px;
}

.form-footer .el-button {
    padding: 12px 40px;
    margin: 0 10px;
}

@media only screen and (max-width: 550px) {
    .image-project-form {
        padding: 10px;
    }
    
    .image-project-form .el-form-item {
        margin-bottom: 15px;
    }
    
    .image-project-form .el-radio-group {
        flex-direction: column;
    }
    
    .image-project-form .el-radio {
        margin-bottom: 10px;
    }
}

.experience-upload {
    padding: 20px;
    background: #f8f9fa;
    border-radius: 4px;
}

.experience-upload .el-upload__tip {
    color: #909399;
    font-size: 12px;
    margin-top: 10px;
}

.dialog-footer {
    text-align: center;
    padding: 20px 0;
    margin-top: 20px;
    border-top: 1px solid #EBEEF5;
}

.dialog-footer .el-button {
    padding: 10px 30px;
    font-size: 14px;
}

.upload-container {
    display: flex;
    align-items: center;
    gap: 10px;
}

.StepCommFileBtn {
    font-size: 14px;
    padding: 8px 20px;
    background: #F5F5F5;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
}

.StepCommFileBtn:hover {
    background: #EBEEF5;
}

.StepCommFileLock {
    font-size: 14px;
    color: #409EFF;
    cursor: pointer;
}

.StepCommFileLock:hover {
    color: #66b1ff;
}

.experience-files {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 10px 0;
}

.experience-file {
    position: relative;
}

.experience-file .LockImg {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    cursor: pointer;
    transition: all 0.3s;
}

.experience-file .LockImg:hover {
    border-color: #409EFF;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>